<div class="rateModal">
    <span class="closeBtn" (click)="close()">
        <mat-icon fontSet="material-icons-round">close</mat-icon>
    </span>
    <div class="title">
        <h1>{{ 'rateDialog.title' | translate }}</h1>
    </div>

    
    <div class="rateModal-product">
        <div class="rateModal-product-image" [style.background-image]="'url(' + order.product.photos[0] + ')'"></div>
        <div class="rateModal-product-info">
            <p>{{ order.product.name }}</p>
            <p>{{ 'orderHistory.orderNumber' | translate }} {{ order.orderNumber }}</p>
        </div>
    </div>

    <div class="rateModal-rate">
        <div class="rateModal-rate-star">
            <mat-icon fontSet="material-icons-round" 
                [ngClass]="{selected: ((rate >= 1 && rateHover === 0) || rateHover >=1)}"
                (mouseenter)="rateHover = 1"
                (mouseleave)="rateHover = 0"
                (click)="rate = 1"
                >star</mat-icon>
            <mat-icon fontSet="material-icons-round" 
                [ngClass]="{selected: ((rate >= 2 && rateHover === 0) || rateHover >=2)}"
                (mouseenter)="rateHover = 2"
                (mouseleave)="rateHover = 0"
                (click)="rate = 2"
                >star</mat-icon>
            <mat-icon fontSet="material-icons-round" 
                [ngClass]="{selected: ((rate >= 3 && rateHover === 0) || rateHover >=3)}"
                (mouseenter)="rateHover = 3"
                (mouseleave)="rateHover = 0"
                (click)="rate = 3"
                >star</mat-icon>
            <mat-icon fontSet="material-icons-round" 
                [ngClass]="{selected: ((rate >= 4 && rateHover === 0) || rateHover >=4)}"
                (mouseenter)="rateHover = 4"
                (mouseleave)="rateHover = 0"
                (click)="rate = 4"
                >star</mat-icon>
            <mat-icon fontSet="material-icons-round" 
                [ngClass]="{selected: ((rate >= 5 && rateHover === 0) || rateHover >=5)}"
                (mouseenter)="rateHover = 5"
                (mouseleave)="rateHover = 0"
                (click)="rate = 5"
                >star</mat-icon>
        </div>
        <p>{{ rate }},0</p>
    </div>
    
    <textarea rows="5" [(ngModel)]="opinion" [placeholder]="'rateDialog.opinion' | translate" maxlength="200"></textarea>
    <span class="counter">{{ opinion.length }} / 200</span>

    <div class="actions">
        <button mat-flat-button class="btn outlined">{{ 'orderHistory.needHelpDialog.cancel' | translate }}</button>
        <button mat-flat-button class="btn default">{{ 'rateDialog.evaluate' | translate }}</button>
    </div>
</div>